import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { BlogFragmentDoc } from '../../fragments/__generated__/Blog.generated';
import { BlogCategoryFragmentDoc } from '../../fragments/__generated__/BlogCategory.generated';
import { BlogArticleFragmentDoc } from '../../fragments/__generated__/BlogArticle.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type BlogQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type BlogQuery = { blog: { id: string, pk: number, description: string, name: string, slug: string, subscribed: boolean, isWholesale: boolean, image: { url: string } } | null };

export type BlogListQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isWholesale?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type BlogListQuery = { blogList: { totalCount: number | null, edges: Array<{ node: { id: string, pk: number, description: string, name: string, slug: string, subscribed: boolean, isWholesale: boolean, categories: Array<{ id: string, pk: number, name: string, slug: string }>, image: { url: string } } }> } };

export type BlogCategoryQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
  firstArticles: Types.Scalars['Int']['input'];
  afterArticles?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderByArticles?: Array<Types.BlogArticleOrder> | Types.BlogArticleOrder;
}>;


export type BlogCategoryQuery = { blogCategory: { description: string, id: string, pk: number, slug: string, name: string, articles: { pageInfo: { hasNextPage: boolean, endCursor: string | null }, edges: Array<{ node: { id: string, pk: number, body: string, title: string, slug: string, authorName: string | null, dateAdded: any, annotation: string, datePublished: any | null, status: string, averageRating: number, userMeasure: number, keywords: string, tags: string, bigThumbnail: string | null, mediumThumbnail: string | null, smallThumbnail: string | null, bigThumbnailWebp: string | null, mediumThumbnailWebp: string | null, smallThumbnailWebp: string | null, author: { id: string, pk: number }, image: { url: string } } }> }, blog: { id: string, pk: number, slug: string, name: string }, image: { url: string } } | null };

export type BlogCategoryListBaseQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  blogSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type BlogCategoryListBaseQuery = { blogCategoryList: { edges: Array<{ node: { id: string, pk: number, name: string, slug: string, thumbnailUrl: string | null, image: { url: string } } }> } };

export type BlogCategoryListQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  firstArticles: Types.Scalars['Int']['input'];
  afterArticles?: Types.InputMaybe<Types.Scalars['String']['input']>;
  blogSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderByArticles?: Array<Types.BlogArticleOrder> | Types.BlogArticleOrder;
}>;


export type BlogCategoryListQuery = { blogCategoryList: { edges: Array<{ node: { description: string, id: string, pk: number, slug: string, name: string, articles: { edges: Array<{ node: { id: string, pk: number, body: string, title: string, slug: string, authorName: string | null, dateAdded: any, annotation: string, datePublished: any | null, status: string, averageRating: number, userMeasure: number, keywords: string, tags: string, bigThumbnail: string | null, mediumThumbnail: string | null, smallThumbnail: string | null, bigThumbnailWebp: string | null, mediumThumbnailWebp: string | null, smallThumbnailWebp: string | null, author: { id: string, pk: number }, image: { url: string } } }> }, blog: { id: string, pk: number, slug: string, name: string }, image: { url: string } } }> } };

export type BlogArticleQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;


export type BlogArticleQuery = { blogArticle: { id: string, pk: number, body: string, title: string, slug: string, authorName: string | null, dateAdded: any, annotation: string, datePublished: any | null, status: string, averageRating: number, userMeasure: number, keywords: string, tags: string, bigThumbnail: string | null, mediumThumbnail: string | null, smallThumbnail: string | null, bigThumbnailWebp: string | null, mediumThumbnailWebp: string | null, smallThumbnailWebp: string | null, categories: Array<{ id: string, pk: number, name: string, slug: string }>, author: { id: string, pk: number }, image: { url: string } } | null };

export type BlogArticleListPaginationQueryVariables = Types.Exact<{
  limit: Types.Scalars['Int']['input'];
  offset: Types.Scalars['Int']['input'];
  categories?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  categoriesSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  blogSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  dateAddedGte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  dateAddedLte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  orderBy: Array<Types.BlogArticleOrder> | Types.BlogArticleOrder;
}>;


export type BlogArticleListPaginationQuery = { blogArticleListPagination: { totalCount: number, pageInfo: { offset: number, limit: number | null }, results: Array<{ id: string, pk: number, body: string, title: string, slug: string, authorName: string | null, dateAdded: any, annotation: string, datePublished: any | null, status: string, averageRating: number, userMeasure: number, keywords: string, tags: string, bigThumbnail: string | null, mediumThumbnail: string | null, smallThumbnail: string | null, bigThumbnailWebp: string | null, mediumThumbnailWebp: string | null, smallThumbnailWebp: string | null, author: { id: string, pk: number }, image: { url: string } }> } };

export type BlogArticleListQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  categories?: Types.InputMaybe<Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input']>;
  categoriesSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  blogSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  dateAddedGte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  dateAddedLte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  orderBy: Array<Types.BlogArticleOrder> | Types.BlogArticleOrder;
  author: Types.Scalars['ID']['input'];
}>;


export type BlogArticleListQuery = { blogArticleList: { totalCount: number | null, pageInfo: { startCursor: string | null, endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ node: { id: string, pk: number, body: string, title: string, slug: string, authorName: string | null, dateAdded: any, annotation: string, datePublished: any | null, status: string, averageRating: number, userMeasure: number, keywords: string, tags: string, bigThumbnail: string | null, mediumThumbnail: string | null, smallThumbnail: string | null, bigThumbnailWebp: string | null, mediumThumbnailWebp: string | null, smallThumbnailWebp: string | null, author: { id: string, pk: number }, image: { url: string } } }> } };

export type BlogArticleListAllQueryVariables = Types.Exact<{
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  blogSlug?: Types.InputMaybe<Types.Scalars['String']['input']>;
  orderBy: Array<Types.BlogArticleOrder> | Types.BlogArticleOrder;
}>;


export type BlogArticleListAllQuery = { blogArticleList: { totalCount: number | null, pageInfo: { startCursor: string | null, endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean }, edges: Array<{ node: { id: string, pk: number, body: string, title: string, slug: string, authorName: string | null, dateAdded: any, annotation: string, datePublished: any | null, status: string, averageRating: number, userMeasure: number, keywords: string, tags: string, bigThumbnail: string | null, mediumThumbnail: string | null, smallThumbnail: string | null, bigThumbnailWebp: string | null, mediumThumbnailWebp: string | null, smallThumbnailWebp: string | null, author: { id: string, pk: number }, image: { url: string } } }> } };


export const BlogDocument = gql`
    query Blog($slug: String!) {
  blog(filters: {slug: {iExact: $slug}}) {
    ...BlogFragment
  }
}
    ${BlogFragmentDoc}`;

/**
 * __useBlogQuery__
 *
 * To run a query within a React component, call `useBlogQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBlogQuery(baseOptions: Apollo.QueryHookOptions<BlogQuery, BlogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogQuery, BlogQueryVariables>(BlogDocument, options);
      }
export function useBlogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogQuery, BlogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogQuery, BlogQueryVariables>(BlogDocument, options);
        }
export type BlogQueryHookResult = ReturnType<typeof useBlogQuery>;
export type BlogLazyQueryHookResult = ReturnType<typeof useBlogLazyQuery>;
export type BlogQueryResult = Apollo.QueryResult<BlogQuery, BlogQueryVariables>;
export function refetchBlogQuery(variables: BlogQueryVariables) {
      return { query: BlogDocument, variables: variables }
    }
export const BlogListDocument = gql`
    query BlogList($first: Int!, $after: String, $isWholesale: Boolean) {
  blogList(first: $first, after: $after, filters: {isWholesale: $isWholesale}) {
    totalCount
    edges {
      node {
        ...BlogFragment
        categories {
          id
          pk
          name
          slug
        }
      }
    }
  }
}
    ${BlogFragmentDoc}`;

/**
 * __useBlogListQuery__
 *
 * To run a query within a React component, call `useBlogListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      isWholesale: // value for 'isWholesale'
 *   },
 * });
 */
export function useBlogListQuery(baseOptions: Apollo.QueryHookOptions<BlogListQuery, BlogListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogListQuery, BlogListQueryVariables>(BlogListDocument, options);
      }
export function useBlogListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogListQuery, BlogListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogListQuery, BlogListQueryVariables>(BlogListDocument, options);
        }
export type BlogListQueryHookResult = ReturnType<typeof useBlogListQuery>;
export type BlogListLazyQueryHookResult = ReturnType<typeof useBlogListLazyQuery>;
export type BlogListQueryResult = Apollo.QueryResult<BlogListQuery, BlogListQueryVariables>;
export function refetchBlogListQuery(variables: BlogListQueryVariables) {
      return { query: BlogListDocument, variables: variables }
    }
export const BlogCategoryDocument = gql`
    query BlogCategory($slug: String!, $firstArticles: Int!, $afterArticles: String, $orderByArticles: [BlogArticleOrder!]! = {dateAdded: DESC}) {
  blogCategory(filters: {slug: {exact: $slug}}) {
    ...BlogCategoryFragment
    articles(
      first: $firstArticles
      after: $afterArticles
      ordering: $orderByArticles
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...BlogArticleFragment
        }
      }
    }
  }
}
    ${BlogCategoryFragmentDoc}
${BlogArticleFragmentDoc}`;

/**
 * __useBlogCategoryQuery__
 *
 * To run a query within a React component, call `useBlogCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogCategoryQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      firstArticles: // value for 'firstArticles'
 *      afterArticles: // value for 'afterArticles'
 *      orderByArticles: // value for 'orderByArticles'
 *   },
 * });
 */
export function useBlogCategoryQuery(baseOptions: Apollo.QueryHookOptions<BlogCategoryQuery, BlogCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogCategoryQuery, BlogCategoryQueryVariables>(BlogCategoryDocument, options);
      }
export function useBlogCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogCategoryQuery, BlogCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogCategoryQuery, BlogCategoryQueryVariables>(BlogCategoryDocument, options);
        }
export type BlogCategoryQueryHookResult = ReturnType<typeof useBlogCategoryQuery>;
export type BlogCategoryLazyQueryHookResult = ReturnType<typeof useBlogCategoryLazyQuery>;
export type BlogCategoryQueryResult = Apollo.QueryResult<BlogCategoryQuery, BlogCategoryQueryVariables>;
export function refetchBlogCategoryQuery(variables: BlogCategoryQueryVariables) {
      return { query: BlogCategoryDocument, variables: variables }
    }
export const BlogCategoryListBaseDocument = gql`
    query BlogCategoryListBase($first: Int!, $after: String, $blogSlug: String) {
  blogCategoryList(
    first: $first
    after: $after
    filters: {blog: {slug: {iExact: $blogSlug}}}
  ) {
    edges {
      node {
        id
        pk
        name
        slug
        image {
          url
        }
        thumbnailUrl(size: "250x300", method: THUMBNAIL_WEBP)
      }
    }
  }
}
    `;

/**
 * __useBlogCategoryListBaseQuery__
 *
 * To run a query within a React component, call `useBlogCategoryListBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogCategoryListBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogCategoryListBaseQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      blogSlug: // value for 'blogSlug'
 *   },
 * });
 */
export function useBlogCategoryListBaseQuery(baseOptions: Apollo.QueryHookOptions<BlogCategoryListBaseQuery, BlogCategoryListBaseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogCategoryListBaseQuery, BlogCategoryListBaseQueryVariables>(BlogCategoryListBaseDocument, options);
      }
export function useBlogCategoryListBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogCategoryListBaseQuery, BlogCategoryListBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogCategoryListBaseQuery, BlogCategoryListBaseQueryVariables>(BlogCategoryListBaseDocument, options);
        }
export type BlogCategoryListBaseQueryHookResult = ReturnType<typeof useBlogCategoryListBaseQuery>;
export type BlogCategoryListBaseLazyQueryHookResult = ReturnType<typeof useBlogCategoryListBaseLazyQuery>;
export type BlogCategoryListBaseQueryResult = Apollo.QueryResult<BlogCategoryListBaseQuery, BlogCategoryListBaseQueryVariables>;
export function refetchBlogCategoryListBaseQuery(variables: BlogCategoryListBaseQueryVariables) {
      return { query: BlogCategoryListBaseDocument, variables: variables }
    }
export const BlogCategoryListDocument = gql`
    query BlogCategoryList($first: Int!, $after: String, $firstArticles: Int!, $afterArticles: String, $blogSlug: String, $orderByArticles: [BlogArticleOrder!]! = {dateAdded: DESC}) {
  blogCategoryList(
    first: $first
    after: $after
    filters: {blog: {slug: {iExact: $blogSlug}}}
  ) {
    edges {
      node {
        ...BlogCategoryFragment
        articles(
          first: $firstArticles
          after: $afterArticles
          ordering: $orderByArticles
        ) {
          edges {
            node {
              ...BlogArticleFragment
            }
          }
        }
      }
    }
  }
}
    ${BlogCategoryFragmentDoc}
${BlogArticleFragmentDoc}`;

/**
 * __useBlogCategoryListQuery__
 *
 * To run a query within a React component, call `useBlogCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogCategoryListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      firstArticles: // value for 'firstArticles'
 *      afterArticles: // value for 'afterArticles'
 *      blogSlug: // value for 'blogSlug'
 *      orderByArticles: // value for 'orderByArticles'
 *   },
 * });
 */
export function useBlogCategoryListQuery(baseOptions: Apollo.QueryHookOptions<BlogCategoryListQuery, BlogCategoryListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogCategoryListQuery, BlogCategoryListQueryVariables>(BlogCategoryListDocument, options);
      }
export function useBlogCategoryListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogCategoryListQuery, BlogCategoryListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogCategoryListQuery, BlogCategoryListQueryVariables>(BlogCategoryListDocument, options);
        }
export type BlogCategoryListQueryHookResult = ReturnType<typeof useBlogCategoryListQuery>;
export type BlogCategoryListLazyQueryHookResult = ReturnType<typeof useBlogCategoryListLazyQuery>;
export type BlogCategoryListQueryResult = Apollo.QueryResult<BlogCategoryListQuery, BlogCategoryListQueryVariables>;
export function refetchBlogCategoryListQuery(variables: BlogCategoryListQueryVariables) {
      return { query: BlogCategoryListDocument, variables: variables }
    }
export const BlogArticleDocument = gql`
    query BlogArticle($slug: String!) {
  blogArticle(filters: {slug: $slug}) {
    ...BlogArticleFragment
    categories {
      id
      pk
      name
      slug
    }
  }
}
    ${BlogArticleFragmentDoc}`;

/**
 * __useBlogArticleQuery__
 *
 * To run a query within a React component, call `useBlogArticleQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogArticleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogArticleQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useBlogArticleQuery(baseOptions: Apollo.QueryHookOptions<BlogArticleQuery, BlogArticleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogArticleQuery, BlogArticleQueryVariables>(BlogArticleDocument, options);
      }
export function useBlogArticleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogArticleQuery, BlogArticleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogArticleQuery, BlogArticleQueryVariables>(BlogArticleDocument, options);
        }
export type BlogArticleQueryHookResult = ReturnType<typeof useBlogArticleQuery>;
export type BlogArticleLazyQueryHookResult = ReturnType<typeof useBlogArticleLazyQuery>;
export type BlogArticleQueryResult = Apollo.QueryResult<BlogArticleQuery, BlogArticleQueryVariables>;
export function refetchBlogArticleQuery(variables: BlogArticleQueryVariables) {
      return { query: BlogArticleDocument, variables: variables }
    }
export const BlogArticleListPaginationDocument = gql`
    query BlogArticleListPagination($limit: Int!, $offset: Int!, $categories: [ID!], $categoriesSlug: String, $blogSlug: String, $dateAddedGte: DateTime = "2020-01-01T15:04:05", $dateAddedLte: DateTime, $orderBy: [BlogArticleOrder!]!) {
  blogArticleListPagination(
    pagination: {limit: $limit, offset: $offset}
    ordering: $orderBy
    filters: {categories: {id: {inList: $categories}, slug: {iExact: $categoriesSlug}, blog: {slug: {iExact: $blogSlug}}}, dateAdded: {lte: $dateAddedLte, gte: $dateAddedGte}}
  ) {
    totalCount
    pageInfo {
      offset
      limit
    }
    results {
      ...BlogArticleFragment
    }
  }
}
    ${BlogArticleFragmentDoc}`;

/**
 * __useBlogArticleListPaginationQuery__
 *
 * To run a query within a React component, call `useBlogArticleListPaginationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogArticleListPaginationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogArticleListPaginationQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      categories: // value for 'categories'
 *      categoriesSlug: // value for 'categoriesSlug'
 *      blogSlug: // value for 'blogSlug'
 *      dateAddedGte: // value for 'dateAddedGte'
 *      dateAddedLte: // value for 'dateAddedLte'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useBlogArticleListPaginationQuery(baseOptions: Apollo.QueryHookOptions<BlogArticleListPaginationQuery, BlogArticleListPaginationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogArticleListPaginationQuery, BlogArticleListPaginationQueryVariables>(BlogArticleListPaginationDocument, options);
      }
export function useBlogArticleListPaginationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogArticleListPaginationQuery, BlogArticleListPaginationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogArticleListPaginationQuery, BlogArticleListPaginationQueryVariables>(BlogArticleListPaginationDocument, options);
        }
export type BlogArticleListPaginationQueryHookResult = ReturnType<typeof useBlogArticleListPaginationQuery>;
export type BlogArticleListPaginationLazyQueryHookResult = ReturnType<typeof useBlogArticleListPaginationLazyQuery>;
export type BlogArticleListPaginationQueryResult = Apollo.QueryResult<BlogArticleListPaginationQuery, BlogArticleListPaginationQueryVariables>;
export function refetchBlogArticleListPaginationQuery(variables: BlogArticleListPaginationQueryVariables) {
      return { query: BlogArticleListPaginationDocument, variables: variables }
    }
export const BlogArticleListDocument = gql`
    query BlogArticleList($first: Int!, $after: String, $categories: [ID!], $categoriesSlug: String, $blogSlug: String, $dateAddedGte: DateTime = "2020-01-01T15:04:05", $dateAddedLte: DateTime, $orderBy: [BlogArticleOrder!]!, $author: ID!) {
  blogArticleList(
    first: $first
    after: $after
    ordering: $orderBy
    filters: {categories: {id: {inList: $categories}, slug: {iExact: $categoriesSlug}, blog: {slug: {iExact: $blogSlug}}}, dateAdded: {lte: $dateAddedLte, gte: $dateAddedGte}, author: {pk: $author}}
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...BlogArticleFragment
      }
    }
  }
}
    ${BlogArticleFragmentDoc}`;

/**
 * __useBlogArticleListQuery__
 *
 * To run a query within a React component, call `useBlogArticleListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogArticleListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogArticleListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      categories: // value for 'categories'
 *      categoriesSlug: // value for 'categoriesSlug'
 *      blogSlug: // value for 'blogSlug'
 *      dateAddedGte: // value for 'dateAddedGte'
 *      dateAddedLte: // value for 'dateAddedLte'
 *      orderBy: // value for 'orderBy'
 *      author: // value for 'author'
 *   },
 * });
 */
export function useBlogArticleListQuery(baseOptions: Apollo.QueryHookOptions<BlogArticleListQuery, BlogArticleListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogArticleListQuery, BlogArticleListQueryVariables>(BlogArticleListDocument, options);
      }
export function useBlogArticleListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogArticleListQuery, BlogArticleListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogArticleListQuery, BlogArticleListQueryVariables>(BlogArticleListDocument, options);
        }
export type BlogArticleListQueryHookResult = ReturnType<typeof useBlogArticleListQuery>;
export type BlogArticleListLazyQueryHookResult = ReturnType<typeof useBlogArticleListLazyQuery>;
export type BlogArticleListQueryResult = Apollo.QueryResult<BlogArticleListQuery, BlogArticleListQueryVariables>;
export function refetchBlogArticleListQuery(variables: BlogArticleListQueryVariables) {
      return { query: BlogArticleListDocument, variables: variables }
    }
export const BlogArticleListAllDocument = gql`
    query BlogArticleListAll($first: Int!, $after: String, $blogSlug: String, $orderBy: [BlogArticleOrder!]!) {
  blogArticleList(
    first: $first
    after: $after
    ordering: $orderBy
    filters: {categories: {blog: {slug: {iExact: $blogSlug}}}}
  ) {
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...BlogArticleFragment
      }
    }
  }
}
    ${BlogArticleFragmentDoc}`;

/**
 * __useBlogArticleListAllQuery__
 *
 * To run a query within a React component, call `useBlogArticleListAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogArticleListAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogArticleListAllQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      blogSlug: // value for 'blogSlug'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useBlogArticleListAllQuery(baseOptions: Apollo.QueryHookOptions<BlogArticleListAllQuery, BlogArticleListAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogArticleListAllQuery, BlogArticleListAllQueryVariables>(BlogArticleListAllDocument, options);
      }
export function useBlogArticleListAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogArticleListAllQuery, BlogArticleListAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogArticleListAllQuery, BlogArticleListAllQueryVariables>(BlogArticleListAllDocument, options);
        }
export type BlogArticleListAllQueryHookResult = ReturnType<typeof useBlogArticleListAllQuery>;
export type BlogArticleListAllLazyQueryHookResult = ReturnType<typeof useBlogArticleListAllLazyQuery>;
export type BlogArticleListAllQueryResult = Apollo.QueryResult<BlogArticleListAllQuery, BlogArticleListAllQueryVariables>;
export function refetchBlogArticleListAllQuery(variables: BlogArticleListAllQueryVariables) {
      return { query: BlogArticleListAllDocument, variables: variables }
    }